export type MidTermFeatures = {
  title?: string
  type?: string
  list: {
    title?: string
    query: string
    api: string
    qValue?: number
    aValue?: string | number
    seo?: boolean
    seoTitle?: string
  }[]
}

export const midTermFeatures: MidTermFeatures[] = [
  {
    type: 'main-feature',
    title: 'امکانات اصلی',
    list: [
      {
        title: 'گرمایشی',
        query: 'heating',
        api: 'features_category[]',
        qValue: 1,
        aValue: 'heating_system',
      },
      {
        title: 'سرمایشی',
        query: 'cooling',
        api: 'features_category[]',
        qValue: 1,
        aValue: 'cooling_system',
      },
      {
        title: 'پارکینگ',
        query: 'parking',
        api: 'parking[capacity]',
        qValue: 1,
        aValue: '1',
      },
      {
        title: 'آسانسور',
        query: 'elevator',
        api: 'features[]',
        qValue: 1,
        aValue: 'elevator',
      },
      {
        title: 'استخر',
        query: 'pool',
        api: 'pool[exist]',
        qValue: 1,
        aValue: 1,
      },
      {
        title: 'وسایل سرو غذا',
        query: 'food_serving',
        api: 'features[]',
        qValue: 1,
        aValue: 'food_serving_equipment',
      },
      {
        title: 'یخچال',
        query: 'refrigerator',
        api: 'features[]',
        qValue: 1,
        aValue: 'refrigerator',
      },
      {
        title: 'اجاق گاز',
        query: 'gas_stove',
        api: 'features[]',
        qValue: 1,
        aValue: 'gas_stove',
      },
      {
        title: 'سرویس فرنگی',
        query: 'european_wc',
        api: 'features[]',
        qValue: 1,
        aValue: 'european_wc',
      },
      {
        title: 'سرویس ایرانی',
        query: 'iranian_wc',
        api: 'features[]',
        qValue: 1,
        aValue: 'iranian_wc',
      },
      {
        title: 'حمام',
        query: 'bathroom',
        api: 'features[]',
        qValue: 1,
        aValue: 'bathroom',
      },

      {
        title: 'لباسشویی',
        query: 'laundry',
        api: 'features[]',
        qValue: 1,
        aValue: 'laundry',
      },
      {
        title: 'ماشین ظرفشویی',
        query: 'dishwasher_machine',
        api: 'features[]',
        qValue: 1,
        aValue: 'dishwasher_machine',
      },
      {
        title: 'پک بهداشتی',
        query: 'health_facilities',
        api: 'features[]',
        qValue: 1,
        aValue: 'health_facilities',
      },
    ],
  },
  {
    type: 'amenities',
    title: 'امکانات رفاهی',
    list: [
      {
        title: 'جکوزی',
        query: 'jacuzzi',
        api: 'features[]',
        qValue: 1,
        aValue: 'hot_tub',
      },
      {
        title: 'باغ',
        query: 'garden',
        api: 'features[]',
        qValue: 1,
        aValue: 'garden',
      },
      {
        title: 'میز بیلیارد',
        query: 'billiard-pool',
        api: 'features[]',
        qValue: 1,
        aValue: 'billiard_table',
        seo: true,
        seoTitle: 'با میزبیلیارد',
      },
      {
        title: 'تراس',
        query: 'balcony',
        api: 'features[]',
        qValue: 1,
        aValue: 'terrace',
        seo: true,
        seoTitle: 'تراس دار (بالکن)',
      },
      {
        title: 'اینترنت',
        query: 'wifi',
        api: 'features[]',
        qValue: 1,
        aValue: 'wifi_internet',
      },
      {
        title: 'مبلمان',
        query: 'furniture',
        api: 'features[]',
        qValue: 1,
        aValue: 'furniture',
      },
      {
        title: 'تلویزیون',
        query: 'tv',
        api: 'features[]',
        qValue: 1,
        aValue: 'television',
      },
      {
        title: 'کنسول بازی',
        query: 'game_console',
        api: 'features[]',
        qValue: 1,
        aValue: 'game_console',
      },
      {
        title: 'حیاط',
        query: 'yard',
        api: 'features[]',
        qValue: 1,
        aValue: 'yard',
      },
    ],
  },
]
